<template>
  <div>
    <check-detail-new v-if="isNewInspection" :data="data" :print-width="printWidth" />
    <check-detail-legacy v-else :data="data" :print-width="printWidth" />
  </div>
</template>

<script>
import CheckDetailNew from "./checkDetailNew.vue";
import CheckDetailLegacy from "./checkDetailLegacy.vue";

export default {
  name: "CheckDetail",
  components: {
    CheckDetailNew,
    CheckDetailLegacy
  },
  props: {
    printWidth: {
      type: Number,
      default: 210
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isNewInspection() {
      const source = this.data || {};
      const detail = source.detail || {};
      return detail.allBrake;
    }
  },
  methods: {
    isNotBlank(value) {
      return value !== undefined && value !== null && String(value).trim() !== "";
    },
    hasArrayData(value) {
      return Array.isArray(value) && value.length > 0;
    }
  }
};
</script>
